import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { blogPosts } from '../data/blogPosts';
import Navbar from '../components/NavBar';
import { motion, AnimatePresence } from 'framer-motion';
import ReactMarkdown from 'react-markdown';

const BlogDetailPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [helpfulCount, setHelpfulCount] = useState(0);
const [hasVoted, setHasVoted] = useState(false);
  const [username, setUsername] = useState('Ziyaretçi');
  const [markdownContent, setMarkdownContent] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        setUsername(payload.username || 'Ziyaretçi');
      } catch {
        setUsername('Ziyaretçi');
      }
    }
  }, []);

  const post = blogPosts.find((p) => p.slug === slug);

  useEffect(() => {
  // Sayacı backend'den al
  fetch(`https://klima-backend-ggo2.onrender.com/api/projects/blog/helpful/${slug}`)
    .then((res) => res.json())
    .then((data) => {
      if (data?.count >= 0) {
        setHelpfulCount(data.count);
      }
    })
    .catch((err) => {
      console.error('Faydalı sayısı alınamadı:', err);
    });

  // Yalnızca bu slug daha önce oylandı mı diye kontrol et
  const votedSlugs = JSON.parse(localStorage.getItem('votedSlugs') || '[]');
  setHasVoted(votedSlugs.includes(slug));
}, [slug]);

  const postIndex = blogPosts.findIndex((p) => p.slug === slug);

const handleHelpfulClick = () => {
  if (hasVoted) return;

  // 1️⃣ Anında artır
  setHelpfulCount((prev) => prev + 1);
  setHasVoted(true);

  const votedSlugs = JSON.parse(localStorage.getItem('votedSlugs') || '[]');
  votedSlugs.push(slug);
  localStorage.setItem('votedSlugs', JSON.stringify(votedSlugs));

  // 2️⃣ Backend'e gönder ama sonucu umursama
  fetch(`https://klima-backend-ggo2.onrender.com/api/projects/blog/helpful/${slug}`, {
    method: 'POST',
  }).catch(() => {
    console.warn('Backend güncellenemedi ama sayaç düşürülmeyecek.');
  });
};

  const prevPost = blogPosts[postIndex + 1];
  const nextPost = blogPosts[postIndex - 1];

  useEffect(() => {
    if (post?.markdown) {
      fetch(post.markdown)
        .then((res) => res.text())
        .then((text) => setMarkdownContent(text))
        .catch(() => setMarkdownContent('Yazı içeriği yüklenemedi.'));
    }
  }, [post]);

  useEffect(() => {
  const styleTag = document.createElement('style');


  styleTag.innerHTML = mobileStyles;
  document.head.appendChild(styleTag);

  return () => {
    document.head.removeChild(styleTag);
  };
}, []);

  if (!post) {
    return (
      <>
        <Navbar username={username} />

        <div style={{ padding: 40 }}>
          <h2>Yazı bulunamadı 😢</h2>
          <button onClick={() => navigate('/blog')} style={{ marginTop: 20 }}>
            Bloga Geri Dön
          </button>
        </div>
      </>
    );
  }

  return (
    <>
      <Navbar username={username} />
   <div
  style={{
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    padding: '40px 20px',
    gap: 40,
    maxWidth: 1300,
    margin: '0 auto',
  }}
>


        {/* Sol taraf: Markdown içerik */}
        <div
  style={{
    flex: 3,
    minWidth: 0,
    width: '100%',
    boxSizing: 'border-box',
  }}
>

          <h1 style={{
            fontSize: '2.2rem',
            marginBottom: 10,
            fontWeight: 'bold',
            color: '#0f172a'
          }}>
            {post.title}
          </h1>
          <p style={{ color: '#666', fontSize: '0.95rem', marginBottom: 30 }}>
            {post.date}
          </p>
<div
  className="blog-content"
  style={{
    fontSize: '1.05rem',
    lineHeight: '1.75',
    color: '#1e293b',
  }}
>

            <ReactMarkdown>{markdownContent}</ReactMarkdown>

           {/*  Faydalı Buluyorum butonu 
<div style={{ marginTop: 40, marginBottom: 40, display: 'flex', alignItems: 'center', gap: 16 }}>
  <button
  onClick={handleHelpfulClick}
  disabled={hasVoted}
  style={{
    backgroundColor: hasVoted ? '#d1fae5' : '#e0f2fe',
    color: hasVoted ? '#047857' : '#0369a1',
    border: 'none',
    padding: '10px 20px',
    borderRadius: 8,
    fontWeight: '600',
    cursor: hasVoted ? 'default' : 'pointer',
    fontSize: '1rem',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    transition: 'all 0.3s ease',
  }}
>
  👍 {hasVoted ? 'Faydalı Bulundu' : 'Faydalı Buluyorum'}
</button>

 <AnimatePresence>
  {helpfulCount > 0 && (
    <motion.div
      key={helpfulCount}
      initial={{ opacity: 0, y: -4 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -4 }}
      transition={{ duration: 0.4 }}
      style={{
        fontSize: '1rem',
        color: '#1e3a8a',
      }}
    >
      {helpfulCount} Kişi Faydalı Buldu
    </motion.div>
  )}
</AnimatePresence>

</div>
*/}
          </div>

          {/* 🔻 Önceki ve Sonraki Yazılar Navigasyonu */}
<div
  className="prev-next-container"
  style={{
    display: 'flex',
    flexDirection: 'column',
    marginTop: '60px',
    gap: '20px',
  }}
>

            {/* Önceki Yazı */}
            {prevPost && (
             <div
  style={{
    backgroundColor: '#eff6ff',
    padding: '16px 20px',
    borderRadius: 10,
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
    width: '100%',
  }}
>

                <button
                  onClick={() => navigate(`/blog/${prevPost.slug}`)}
                  style={{
                    backgroundColor: '#1e3a8a',
                    color: '#fff',
                    padding: '8px 16px',
                    borderRadius: 6,
                    border: 'none',
                    cursor: 'pointer',
                    fontWeight: '600',
                    marginBottom: 10,
                  }}
                >
                  ← Önceki Yazı
                </button>
                <div
                  style={{
                    color: '#1e293b',
                    fontSize: '1rem',
                    fontWeight: '500',
                  }}
                >
                  {prevPost.title}
                </div>
              </div>
            )}

            {/* Sonraki Yazı */}
            {nextPost && (
           <div
  style={{
    backgroundColor: '#fefce8',
    padding: '16px 20px',
    borderRadius: 10,
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
    width: '100%',
    textAlign: 'right',
  }}
>

                <button
                  onClick={() => navigate(`/blog/${nextPost.slug}`)}
                  style={{
                    backgroundColor: '#1e3a8a',
                    color: '#fff',
                    padding: '8px 16px',
                    borderRadius: 6,
                    border: 'none',
                    cursor: 'pointer',
                    fontWeight: '600',
                    marginBottom: 10,
                  }}
                >
                  Sonraki Yazı →
                </button>
                <div
                  style={{
                    color: '#1e293b',
                    fontSize: '1rem',
                    fontWeight: '500',
                  }}
                >
                  {nextPost.title}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Sağ taraf: Diğer yazılar */}
        <div className="sidebar" style={{ flex: 1 }}>
          <h3 style={{ marginBottom: 20, color: '#1e293b' }}>📌 Diğer Yazılar</h3>
          {blogPosts
            .filter((p) => p.slug !== slug)
            .map((p) => (
              <div
                key={p.slug}
                onClick={() => navigate(`/blog/${p.slug}`)}
                style={{
                  cursor: 'pointer',
                  marginBottom: 24,
                  border: '1px solid #e2e8f0',
                  borderRadius: 8,
                  padding: 12,
                  background: '#fff',
                  transition: 'all 0.2s ease',
                }}
              >
                {p.image && (
                  <img
                    src={p.image}
                    alt={p.title}
                    style={{
                      width: '100%',
                      borderRadius: 6,
                      marginBottom: 8,
                      objectFit: 'cover'
                    }}
                  />
                )}
                <div>
                  <p style={{
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: '#1e40af',
                    marginBottom: 4
                  }}>
                    {p.title}
                  </p>
                  <p style={{ fontSize: '0.85rem', color: '#666' }}>{p.date}</p>
                </div>
              </div>
            ))}
        </div>
      </div>
      {/* 📱 Mobilde altta gösterilecek Diğer Yazılar */}

      {/* 🔹 HVAC Ürünlerini Tasarla Kutusu */}
<div
  style={{
    backgroundImage: 'url("/assets/home-bg.png")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    padding: '80px 20px',
    marginTop: '80px',
  }}
>
  <div
    style={{
      background: 'rgba(255, 255, 255, 0.1)',
      borderRadius: '20px',
      padding: '40px 30px',
      backdropFilter: 'blur(60px)',
      boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
      maxWidth: '960px',
      margin: '0 auto',
      textAlign: 'center',
      color: '#fff',
    }}
  >
    <h2 style={{
      fontSize: '2.2rem',
      fontWeight: '800',
      marginBottom: '20px',
      color: '#f1f5f9',
      textShadow: '1px 1px 2px rgba(0,0,0,0.6)',
    }}>
      HVAC Ürünlerinizi Tasarlayın
    </h2>
    <p style={{
      fontSize: '1.05rem',
      color: '#e2e8f0',
      lineHeight: '1.6',
      textShadow: '1px 1px 3px rgba(0,0,0,0.7)',
      marginBottom: '36px',
    }}>
      Klima Santrali, IGK, VRF/VRV ve Fan Grubu cihazlarınızı kolayca seçin.
      <br />
      <strong><em>Projelerinizi oluşturun, kaydedin ve teklif isteyin.</em></strong>
    </p>
    <div style={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: 16,
      justifyContent: 'center',
    }}>
      <button onClick={() => navigate('/tasarim')} style={mainBtn('#3b82f6')}>
        🌬️ Klima Santrali
      </button>
      <button onClick={() => navigate('/igk-secim')} style={mainBtn('#10b981')}>
        ♻️ Isı Geri Kazanım Cihazı
      </button>
      <button onClick={() => navigate('/vrf')} style={mainBtn('#8b5cf6')}>
        ❄️ VRF / VRV
      </button>
      <button onClick={() => navigate('/fan-secim')} style={mainBtn('#f97316')}>
        🌀 Fan Grubu
      </button>
    </div>
  </div>
</div>

<div className="mobile-sidebar">
  <h3 style={{ marginBottom: 20, color: '#1e293b' }}>📌 Diğer Yazılar</h3>
  {blogPosts
    .filter((p) => p.slug !== slug)
    .map((p) => (
      <div
        key={p.slug}
        onClick={() => navigate(`/blog/${p.slug}`)}
        style={{
          cursor: 'pointer',
          marginBottom: 24,
          border: '1px solid #e2e8f0',
          borderRadius: 8,
          padding: 12,
          background: '#fff',
          transition: 'all 0.2s ease',
        }}
      >
        {p.image && (
          <img
            src={p.image}
            alt={p.title}
            style={{
              width: '100%',
              borderRadius: 6,
              marginBottom: 8,
              objectFit: 'cover',
            }}
          />
        )}
        <div>
          <p
            style={{
              fontSize: '1rem',
              fontWeight: '600',
              color: '#1e40af',
              marginBottom: 4,
            }}
          >
            {p.title}
          </p>
          <p style={{ fontSize: '0.85rem', color: '#666' }}>{p.date}</p>
        </div>
      </div>
    ))}
</div>

    </>
  );
};

const mainBtn = (bgColor) => ({
  backgroundColor: bgColor,
  color: 'white',
  border: 'none',
  padding: '14px 28px',
  borderRadius: '10px',
  fontWeight: '600',
  fontSize: '1rem',
  cursor: 'pointer',
  boxShadow: `0 4px 12px ${bgColor}80`,
  transition: 'all 0.3s ease',
});

const mobileStyles = `
@media (max-width: 768px) {
.blog-content {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.blog-content > div {
  padding-left: 12px !important;
  padding-right: 12px !important;
  box-sizing: border-box !important;
}

  .sidebar {
    display: none !important;
  }

  .mobile-sidebar {
    display: block !important;
    padding: 0 12px;
  }

  .mobile-sidebar img {
    max-width: 100%;
    border-radius: 6px;
  }

  .blog-content p,
  .blog-content li,
  .blog-content h1,
  .blog-content h2,
  .blog-content h3 {
    font-size: 0.95rem !important;
    padding-left: 12px;
    padding-right: 12px;
    box-sizing: border-box;
  }

  /* Önceki/Sonraki kartları dikey hizala ve genişliği %100 yap */
  .prev-next-container {
    display: flex !important;
    flex-direction: column !important;
    gap: 12px !important;
    width: 100% !important;
  }

  .prev-next-container > div {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    text-align: left !important;
  }

  .prev-next-container button {
    width: 100% !important;
  }
      .blog-content img {
    max-width: 100% !important;
    height: auto !important;
    display: block !important;
    margin: 24px auto !important;
    border-radius: 8px;
  }

}
`;




export default BlogDetailPage;
